import type { Place } from "../types";
import { SelectField } from "./fields";

type Props = {
  places: Place[];
  selected: string;
  onSelect: (name: string) => void;
  allowAll?: boolean;
  compact?: boolean;
  wide?: boolean;
};

export default function PlaceSwitcher({ places, selected, onSelect, allowAll = false, compact = false, wide = false }: Props) {
  if (places.length === 0) return null;
  if (places.length < 2 && !allowAll) return null;
  const options = [
    ...(allowAll ? [{ value: "all", label: "Tous les établissements" }] : []),
    ...places.map((p) => ({ value: p.name, label: p.title })),
  ];
  const box = wide ? "w-full sm:w-[42rem] max-w-full" : compact ? "w-full max-w-sm" : "w-full max-w-md";
  return (
    <div className={`flex min-w-0 items-center gap-3 ${box}`}>
      <span className="hidden shrink-0 text-xs text-slate-500 sm:inline">Établissement</span>
      <div className="min-w-0 flex-1">
        <SelectField value={selected} onChange={onSelect} options={options} />
      </div>
    </div>
  );
}
